import {ReactNode, useCallback} from 'react'
import {SidebarBody, SidebarSlot, SidebarWrapper} from '@/components/ui/sidebar-atoms/SidebarAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useAgendaNavigation} from '@/features/agenda/hooks/useAgendaNavigation'
import {AgendaTargetControl} from '@/features/agenda/components/agenda-target-control/AgendaTargetControl'
import {AgendaEntity} from '@/features/agenda/types'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {useAgendaSearchParams} from '@/features/agenda/hooks/useAgendaSearchParams'

export const AgendaSidebar = ({children}: {children: ReactNode}) => {
    const {params, navigateToEntity} = useAgendaNavigation()
    const {clearSearchParams} = useAgendaSearchParams()

    const handleChangeTarget = useCallback(
        (target: AgendaEntity) => {
            navigateToEntity(target)
            clearSearchParams()
        },
        [navigateToEntity, clearSearchParams]
    )

    return (
        <SidebarWrapper>
            <SidebarBody>
                <ScrollArea scrollbar={<Scrollbar />} style={{height: '100%'}}>
                    <SidebarSlot>
                        <Flexbox direction="column" gap={3} fullWidth>
                            {params.entity && (
                                <AgendaTargetControl value={params.entity} onChange={handleChangeTarget} />
                            )}
                            {children}
                        </Flexbox>
                    </SidebarSlot>
                </ScrollArea>
            </SidebarBody>
        </SidebarWrapper>
    )
}
